import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentMethod } from '@/hooks/api/models';

/**
 * 0510. 支払方法一覧
 * [GET] /payment_methods
 */
const paymentMethods = (): Promise<PaymentMethod[]> => {
  return axios.get(`/api/payment_methods`);
};

export const usePaymentMethods = () => {
  return useQuery({
    queryKey: ['payment_methods'],
    queryFn: () => paymentMethods(),
  });
};
